<template>
  <v-app dark>
    <v-content>
      <v-container fill-height fluid>
        <v-layout align-center justify-center>
          <v-flex xs12>
            <h1 class="display-2 text-xs-center">Damian's Web Fusée Gelée Launcher</h1>
            <v-progress-linear v-if="!initialized" color="red" :indeterminate="true"></v-progress-linear>
            <router-view v-else />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app>
        <credits-and-additional-info/>
    </v-footer>
  </v-app>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import CreditsAndAdditionalInfo from "./components/CreditsAndAdditionalInfo.vue";

export default {
  created() {
    setTimeout(() => this.initialize(), 2500);
  },
  computed: {
    ...mapState(["compatibleBrowser"]),
    ...mapGetters(["initialized"])
  },
  methods: {
    ...mapActions(["initialize"])
  },
  components: { CreditsAndAdditionalInfo }
};
</script>
